<template>
    <div>
        <!-- alias -->
        <div v-if="isFieldEnabled('alias')" class="field">
            <label class="">
                {{"components.pages.profile.settings.alias" | translate}}
                <span
                    v-show="isFieldRequired('alias')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.alias"
                    v-validate="'min:3|max:50'"
                    data-vv-name="alias"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('alias')}"
                    :disabled="profile.isProfileFrozen && isFieldRequired('alias')"
                    class="input"
                    type="text"
                />
            </div>
            <p
                class="help is-danger"
                v-if="errors.has('alias:min')"
            >{{"components.pages.profile.validation.alias min length" | translate}}</p>
            <p
                class="help is-danger"
                v-if="errors.has('alias:max')"
            >{{"components.pages.profile.validation.alias max length" | translate}}</p>
        </div>

        <!-- email -->
        <div v-if="isFieldEnabled('email')" class="field">
            <label class="">
                {{"components.pages.profile.settings.email" | translate}}
                <span
                    v-show="isFieldRequired('email')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.email"
                    :disabled="profile.isProfileFrozen && isFieldRequired('email')"
                    v-validate="{regex:/^[^@]+@[^@]+\.[^@]+$/}"
                    data-vv-name="email"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('email')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('email:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.email format" | translate }}</span>
        </div>

        <!-- phone number -->
        <div v-if="isFieldEnabled('phoneNumber')" class="field">
            <label class="">
                {{"components.pages.profile.settings.phone number" | translate}}
                <span
                    v-show="isFieldRequired('phoneNumber')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.phoneNumber"
                    :disabled="profile.isProfileFrozen && isFieldRequired('phoneNumber')"
                    v-validate="{regex:/^\d+$/}"
                    data-vv-name="phoneNumber"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('phoneNumber')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('phoneNumber:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.phone number format" | translate }}</span>
        </div>

        <!-- first name -->
        <div v-if="isFieldEnabled('firstName')" class="field">
            <label class="">
                {{"components.pages.profile.settings.first name" | translate}}
                <span
                    v-show="isFieldRequired('firstName')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.firstName"
                    :disabled="profile.isProfileFrozen && isFieldRequired('firstName')"
                    data-vv-name="firstName"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('firstName')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('firstName:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.first name format" | translate }}</span>
        </div>

        <!-- middle name -->
        <div v-if="isFieldEnabled('middleName')" class="field">
            <label class="">
                {{"components.pages.profile.settings.middle name" | translate}}
                <span
                    v-show="isFieldRequired('middleName')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.middleName"
                    :disabled="profile.isProfileFrozen && isFieldRequired('middleName')"
                    data-vv-name="middleName"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('middleName')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('middleName:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.middle name format" | translate }}</span>
        </div>

        <!-- last name -->
        <div v-if="isFieldEnabled('lastName')" class="field">
            <label class="">
                {{"components.pages.profile.settings.last name" | translate}}
                <span
                    v-show="isFieldRequired('lastName')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.lastName"
                    :disabled="profile.isProfileFrozen && isFieldRequired('lastName')"
                    data-vv-name="lastName"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('lastName')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('lastName:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.last name format" | translate }}</span>
        </div>

        <!-- date of birth -->
        <div v-if="isFieldEnabled('dateOfBirth')" class="field">
            <label class="">
                {{"components.pages.profile.settings.date of birth" | translate}}
                <span
                    v-show="isFieldRequired('dateOfBirth')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    ref="dateOfBirth"
                    class="input"
                    type="text"
                    readonly
                    :disabled="profile.isProfileFrozen && isFieldRequired('dateOfBirth')"
                />
            </div>
        </div>

        <!-- passport -->
        <div v-if="isFieldEnabled('passport')" class="field">
            <label class="">
                {{"components.pages.profile.settings.passport" | translate}}
                <span
                    v-show="isFieldRequired('passport')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.passport"
                    :disabled="profile.isProfileFrozen && isFieldRequired('passport')"
                    class="input"
                    type="text"
                    maxlength="200"
                />
            </div>
        </div>

        <!-- address -->
        <div v-if="isFieldEnabled('address')" class="field">
            <label class="">
                {{"components.pages.profile.settings.address" | translate}}
                <span
                    v-show="isFieldRequired('address')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.address"
                    :disabled="profile.isProfileFrozen && isFieldRequired('address')"
                    class="input"
                    type="text"
                    maxlength="300"
                />
            </div>
        </div>

        <!-- inn -->
        <div v-if="isFieldEnabled('inn')" class="field">
            <label class="">
                {{"components.pages.profile.settings.inn" | translate}}
                <span
                    v-show="isFieldRequired('inn')"
                    class="has-text-danger"
                >*</span>
            </label>
            <div class="control">
                <input
                    v-model="profile.inn"
                    :disabled="profile.isProfileFrozen && isFieldRequired('inn')"
                    v-validate="{regex:/^\d+$/}"
                    data-vv-name="inn"
                    data-vv-validate-on="change"
                    :class="{'is-danger': errors.has('inn')}"
                    class="input"
                    type="text"
                    maxlength="50"
                />
            </div>
            <span
                v-if="errors.has('inn:regex')"
                class="help is-danger"
            >{{ "components.pages.profile.validation.inn format" | translate }}</span>
        </div>

        <div v-if="!profile.isProfileFrozen && anyRequiredFields" class="message">
            <div class="message-body">
                <span style="white-space: pre-line;">
                    <span class="has-text-danger">*</span>
                    <span>{{ "components.pages.profile.settings.required fields message" | translate }}</span>
                </span>
            </div>
        </div>

        <div v-if="!profile.isProfileFrozen && anyRequiredFields" class="message is-warning">
            <div class="message-body">
                <span
                    style="white-space: pre-line;"
                >{{ "components.pages.profile.settings.actual info message" | translate }}</span>
            </div>
        </div>

        <div class="field" v-show="isSuccess">
            <label class="label has-text-success">{{"components.pages.profile.settings.success" | translate}}</label>
        </div>

        <div class="field">
            <div class="control submit-buttons">
                <button
                    class="button is-link button-submit"
                    @click="saveProfile()"
                    :disabled="errors.has('alias')"
                >{{"components.pages.profile.settings.save" | translate}}</button>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import flatpickr from 'flatpickr';
import moment from 'moment-timezone';

import playerService from '../../../../../../_common/services/player.service';

export default {
    $_veeValidate: { validator: 'new' },
    data() {
        return {
            profile: {
                alias: null,
                phoneNumber: null,
                firstName: null,
                middleName: null,
                lastName: null,
                dateOfBirth: null,
                passport: null,
                address: null,
                inn: null,
                isProfileFrozen: false
            },
            calendar: null,
            anyRequiredFields: false,
            isSuccess: false
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        profileFields() {
            return this.client && this.client.view.profile.profileFields;
        }
    },
    async mounted() {
        this.profile = await playerService.getProfile();
        this.anyRequiredFields = playerService.anyRequiredFields(this.profileFields);

        let calendarOptions = {
            enableTime: false,
            time_24hr: true,
            disableMobile: 'true',
            onOpen: function(selectedDates, dateStr, instance) {
                setTimeout(function() {
                    instance.open();
                }, 200);
            }
        };

        if (this.isFieldEnabled('dateOfBirth')) {
            if (this.profile.dateOfBirth) calendarOptions.defaultDate = moment(this.profile.dateOfBirth).toDate();
            this.calendar = flatpickr(this.$refs.dateOfBirth, calendarOptions);
        }
    },
    methods: {
        async saveProfile() {
            await this.$validator.validateAll();
            if (this.errors.any()) return;
            this.isSuccess = false;
            if (this.isFieldEnabled('dateOfBirth')) {
                let selectedDate = this.calendar.selectedDates[0];
                this.profile.dateOfBirth = moment(selectedDate).toISOString();
            }
            await playerService.saveProfile(this.profile);
            await Vue.state.player.reload();
            this.profile = await playerService.getProfile();
            this.anyRequiredFields = playerService.anyRequiredFields(this.profileFields);
            if (!Vue.state.player.isLoggedIn()) this.$router.push('/');
            this.isSuccess = true;
        },
        getProfileField(fieldName) {
            return playerService.getProfileField(this.profileFields, fieldName);
        },
        isFieldEnabled(fieldName) {
            return playerService.isFieldEnabled(this.profileFields, fieldName);
        },
        isFieldRequired(fieldName) {
            return playerService.isFieldRequired(this.profileFields, fieldName);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/profile/settings.vue